<template>
  <v-container class="ma-0">
    <v-row class="">
      <v-col cols="12">
        <v-alert dense type="error" outlined text dismissible transition="slide-x-transition"
          class="py-0 text-uppercase" v-for="(item, index) in updateErrors" :key="index">
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col lg="4" cols="12">
        <v-text-field label="Supplier ID" :value="supplierId" disabled></v-text-field>
      </v-col>
      <v-col lg="4" cols="12">
        <v-text-field label="Stock Code" :value="stockCode" disabled></v-text-field>
      </v-col>
      <v-col lg="4" cols="12">
        <v-text-field label="Transaction Date" type="date" v-model="dateTransaction"></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field label="Cost Per Unit" prefix="₱" type="number" v-model="cost"></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field label="Quantity" type="number" v-model="quantity" :suffix="unit"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model="notes" auto-grow no-resize rows="1">
          <template v-slot:label>
            <div>
              Notes <small>(reason)</small>
            </div>
          </template>
        </v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn color="green" @click="initUpdate" :loading="updating">
          Save Lost Product
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { moneyMixin } from './../../mixins/helper.mixins'
import { mapState, mapActions } from 'vuex'

let suppProductFetchDelay = null

function inputVars() {
  return {
    id: null,
    supplierId: null,
    cost: null,
    stockCode: null,
    unit: '',
    quantity: null,
    dateTransaction: null,
    notes: null,
  }
}

export default {
  name: 'editRecievedInventories',
  data() {
    return {
      ...inputVars(),
    }
  },
  computed: {
    ...mapState({
      updateErrors: state => state.lostInventory.updateErrors,
      updateSuccess: state => state.lostInventory.updateSuccess,
      updating: state => state.lostInventory.updating,
    }),
  },
  watch: {
    updateSuccess(val) {
      if (val) {
        this.reset(inputVars())
        this.closeDialog()
      }
    },
  },
  methods: {
    ...mapActions({
      fetchSuppliers: 'supplier/fetch',
      fetchSupplierProducts: 'supplierProduct/fetch',
      fetchUnitsAll: 'unit/fetchAll',
      checkErrors: 'lostInventory/checkErrors',
      update: 'lostInventory/update',
    }),
    initfetchSupplierProducts() {
      clearTimeout(suppProductFetchDelay)
      suppProductFetchDelay = setTimeout(() => {
        this.fetchSupplierProducts(this.supplierId)
      }, 500)
    },
    filterComboBox(item, queryText, itemText) {
      const regX = new RegExp(queryText, 'i')
      return regX.test(`${item.unit}${item.description}`)
    },
    closeDialog() {
      this.$emit('close-dialog')
    },
    populateInputs(data) {
      this.id = data.id
      this.supplierId = data.supplier_id
      this.stockCode = data.stock_code
      this.cost = data.cost
      this.unit = data.unit
      this.quantity = data.quantity
      this.dateTransaction = data.date_lost
      this.notes = data.notes
    },
    reset(v) {
      Object.keys(v).forEach(e => {
        this[e] = v[e]
      })
    },
    dateFormat(ndate) {
      const date = new Date(ndate)
      const year = date.getFullYear()
      const month = (`${date.getMonth() + 1}`).padStart(2, '0')
      const day = (`${date.getDate()}`).padStart(2, '0')

      return `${month}/${day}/${year}`
    },
    deleteTempUnit(index) {
      this.items.splice(index, 1)
    },
    initUpdate() {
      const data = {
        cost: this.cost,
        unit: this.unit,
        quantity: this.quantity,
        date_lost: this.dateTransaction,
        notes: this.notes,
      }
      this.update({
        id: this.id,
        data,
      })
    },
    computeSupplierProdcts(e) {
      const stock = e.stock
      const unit = stock.unit
      let qRecieved = 0
      let qSale = 0
      let qLost = 0
      if (e.recieved_inventory.length) {
        qRecieved = e.recieved_inventory[0].quantity
      }

      if (e.sale_inventory.length) {
        qSale = e.sale_inventory[0].quantity
      }

      if (e.lost_inventory.length) {
        qLost = e.lost_inventory[0].quantity
      }

      return {
        ...e,
        unitDesc: unit.description,
        productName: stock.product_name,
        brandName: stock.brand_name,
        cost: stock.cost,
        quantity: this.quantity,
        date_lost: this.dateTransaction,
        qRemaining: qRecieved - (qSale + qLost),
      }
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
<style lang="scss" scoped>
.truncate {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
